import React from "react";
import AnimatedPage from "../AnimatedPage";

const Tanfr = () => {
  return (
    <AnimatedPage>
      <div className="iframe__ctn">
        <iframe title="Site Naolib" src="https://www.naolib.fr/"></iframe>
      </div>
    </AnimatedPage>
  );
};

export default Tanfr;
